const AEDInstructionData = [
  {
    step: 1,
    description: "<strong><span class='highlight'>Not breathing</span> → <span class='highlight'>Call 112</span> → <span class='highlight'>Get AED </span> → Begin CPR</strong>",
    url: "../../../images/animations/gif7.gif"
  },
  {
    step: 2,
    description: "<strong><span class='highlight'>Turn on AED</span> → Follow voice prompts</strong>",
    url: "../../images/animationAED/gif-1.gif"
  },
  {
    step: 3,
    description: "<strong><span class='highlight'>Remove clothing</span> → Ensure chest is <span class='highlight'>bare and dry</span></strong>",
    url: "../../images/animationAED/gif-2.gif"
  },
  {
    step: 4,
    description: "<strong><span class='highlight'>Peel pads</span> → <span class='highlight'>Upper right chest</span> & <span class='highlight'>Lower left chest</span></strong>",
    url: "../../images/animationAED/gif-3.gif"
  },
  {
    step: 5,
    description: "<strong><span class='highlight'>Do not touch victim</span> → Wait until AED finishes analysis</strong>",
    url: "../../images/animationAED/gif-4.gif"
  },
  {
    step: 6,
    description: "<span class='highlight'>Stand clear</span> → Press <span class='highlight'>'Shock'</span> → Skip step if no shock needed",
    url: "../../images/animationAED/gif-5.gif"
  },
  {
    step: 7,
    description: "<strong><span class='highlight'>Resume 30 compressions & 2 breaths</span> → Follow AED until patient recovers or medical help arrives</strong>",
    url: "../../images/animationAED/gif-6.gif"
  },
];

export default AEDInstructionData;
